import React from 'react';
import PropTypes from 'prop-types';
import { SORT_DIRECTIONS } from './dashboard-dynamic-fields-table';
import { getLastUpdatedTootlTip } from '../../dashboard-util/dashboard-utils';
import { FIELD_TYPES } from '../../../../components/DynamicField/Tasks/utils/utils';

const DashboardDynamicFieldsTableHeader = ({
    isModal,
    isAdmin,
    isStaffer,
    columns,
    sortDirection,
    setSortDirection,
    sortColumnIdx,
    setSortColumnIdx,
    fieldType,
    setFieldType
}) => {
    const handleSelectSort = (idx, fieldType) => {
        setFieldType(fieldType);
        if (sortColumnIdx !== idx) {
            setSortColumnIdx(idx);
            setSortDirection(SORT_DIRECTIONS.DOWN);
            return;
        }

        switch (sortDirection) {
            case SORT_DIRECTIONS.DOWN:
                setSortDirection(SORT_DIRECTIONS.UP);
                break;
            case SORT_DIRECTIONS.UP:
            default:
                setSortDirection(SORT_DIRECTIONS.NONE);
                setSortColumnIdx(SORT_DIRECTIONS.NONE);
        }
    }

    const handleSortArrowClass = (idx) => {
        if (sortColumnIdx !== idx) return '';

        switch (sortDirection) {
            case SORT_DIRECTIONS.DOWN:
                return 'sort-button-up';
            case SORT_DIRECTIONS.UP:
                return 'sort-button';
            default:
                return '';
        }
    }

    const renderColumnHeader = (idx, content, fieldType = '') => {     
        return (
            <th key={idx} className={`${isModal ? 'modal' : 'normal'}-project-by-col-1 p-0`}>
                <h6 className="mb-0">
                    { (isAdmin || isStaffer) && (idx === 5 || idx === 6 || idx === 7) ?
                            <div className="sort-label">{content}</div>
                        :
                            <div className="sort-label" onClick={() => handleSelectSort(idx, fieldType)}>
                                {content}
                                {<button className={handleSortArrowClass(idx)} />}
                            </div>
                    }
                </h6>
            </th>
        );
    };

const renderColumn = (column, idx) => {
        const columnKey = column?.toLowerCase().replace(/\s/g, '').replace(/:$/, '');
        const isLastUpdated = columnKey === "lastupdated";
        const isMdsDirectorsVps = columnKey === "mds";
        const isNewMDVPDField = columnKey  === "vps" || columnKey  === "directors";

        if (isLastUpdated) {
            return getLastUpdatedTootlTip(renderColumnHeader(idx, column?.toUpperCase() || "", FIELD_TYPES.date));
        } else if (isMdsDirectorsVps && isModal) {
            return renderColumnHeader(idx, "MDs/Directors/VPs");
        } else if (isNewMDVPDField) {
            return null;
        } else if (!isMdsDirectorsVps) {
            return renderColumnHeader(idx, column?.toUpperCase() || "", FIELD_TYPES.time);
        }
        return null;
    };

    return (
        <thead className="stickyHeader">
            <tr className={`${isModal ? 'modal-row' : ''} project-table-row project-by-padding `}>
                {columns.map((column, idx) => renderColumn(column, idx))}
            </tr>
        </thead>
    );
};

DashboardDynamicFieldsTableHeader.propTypes = {
    isModal: PropTypes.bool,
    isAdmin: PropTypes.bool,
    isStaffer: PropTypes.bool,
    columns: PropTypes.arrayOf(PropTypes.string),
    sortDirection: PropTypes.string,
    setSortDirection: PropTypes.func,
    sortColumnIdx: PropTypes.number,
    setSortColumnIdx: PropTypes.func,
    fieldType: PropTypes.string,
    setFieldType: PropTypes.func
};

export default DashboardDynamicFieldsTableHeader;
